import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=404f2a36"
import script from "./Tiptap.vue?vue&type=script&lang=ts"
export * from "./Tiptap.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Tiptap.vue?vue&type=style&index=0&id=404f2a36&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports